import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SidenavDirection } from '@app/shared/modules/template/components/sidenav/sidenav';
import { SidenavLearningTrailsComponent } from '../learning-trails/components/sidenav-learning-trails/sidenav-learning-trails.component';
import { SidenavLearningAnnexComponent } from './components/sidenav-learning-annex/sidenav-learning-annex.component';
import { SidenavLearningFormTrailsComponent } from './components/sidenav-learning-form-trails/sidenav-learning-form-trails.component';
import { SidenavLearningStudioCategoryComponent } from './components/sidenav-learning-studio-category/sidenav-learning-studio-category.component';
import { SidenavLearningStudioComponent } from './components/sidenav-learning-studio/sidenav-learning-studio.component';
import { SidenavLearningUnitComponent } from './components/sidenav-learning-unit/sidenav-learning-unit.component';
import { CourseGuard } from './guards/course.guard';
import { CourseDeshboardComponent } from './pages/course-dashboard/course-dashboard.component';
import { CoursesComponent } from './pages/courses/courses.component';
import { ReportComponent } from './pages/report/report.component';
import { ShowcaseComponent } from './pages/showcase/showcase.component';
import { StudioComponent } from './pages/studio/studio.component';
import { ElementComponent } from './pages/trail/trail.component';
import { UnitComponent } from './pages/unit/unit.component';
import { courseResolver } from './resolvers/course.resolver';
import { TrailResolver } from './resolvers/trail.resolver';
import { vitrineResolver } from './resolvers/vitrine.resolver';
import { Role } from '@app/shared/roles';

const routes: Routes = [
  {
    path: '',
    canActivate: [CourseGuard],
    children: [
      {
        path: 'estudio',
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.estudio.titulo',
          role: [Role.learningTrails.studio],
        },
        children: [
          {
            path: '',
            resolve: {
              [SidenavDirection.Start]: () => ({ componentRef: SidenavLearningStudioComponent, opened: true }),
              [SidenavDirection.End]: () => ({
                componentRef: SidenavLearningStudioCategoryComponent,
                closedAnchor: true,
              }),
            },
            component: StudioComponent,
          },
          {
            path: 'trilha/cadastro/:course_id',
            resolve: {
              [SidenavDirection.Start]: () => ({
                componentRef: SidenavLearningFormTrailsComponent,
                opened: true,
              }),
            },
            component: ElementComponent,
          },
          {
            path: 'trilha/cadastro/:course_id/:subdivision_id',
            resolve: {
              [SidenavDirection.Start]: () => ({
                componentRef: SidenavLearningFormTrailsComponent,
                opened: true,
              }),
            },
            component: ElementComponent,
          },
          {
            path: 'trilha/:trail_slug',
            resolve: {
              [SidenavDirection.Start]: () => ({
                componentRef: SidenavLearningFormTrailsComponent,
                opened: true,
              }),
              courseData: TrailResolver,
            },
            component: ElementComponent,
          },
        ],
      },
      {
        path: 'vitrine',
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.vitrine.titulo',
          role: [Role.learningTrails.showcase],
        },
        resolve: {
          [SidenavDirection.Start]: () => ({
            componentRef: SidenavLearningTrailsComponent,
            opened: true,
          }),
        },
        component: ShowcaseComponent,
      },
      {
        path: 'vitrine/:trail_slug',
        resolve: {
          courseResolverData: vitrineResolver,
          [SidenavDirection.Start]: () => ({
            componentRef: SidenavLearningUnitComponent,
            opened: true,
          }),
          [SidenavDirection.End]: () => ({
            componentRef: SidenavLearningAnnexComponent,
            opened: false,
          }),
        },
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.unit.titulo',
          role: [Role.learningTrails.showcase],
        },
        component: UnitComponent,
      },

      {
        path: 'cursos',
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.courses.titulo',
          role: [Role.learningTrails.course],
        },
        resolve: {
          [SidenavDirection.Start]: () => ({
            componentRef: SidenavLearningTrailsComponent,
            opened: true,
          }),
        },
        component: CoursesComponent,
      },
      {
        path: 'cursos/:event_id/:trail_slug',
        resolve: {
          courseResolverData: courseResolver,
          [SidenavDirection.Start]: () => ({
            componentRef: SidenavLearningUnitComponent,
            opened: true,
          }),
          [SidenavDirection.End]: () => ({
            componentRef: SidenavLearningAnnexComponent,
            opened: false,
          }),
        },
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.unit.titulo',
          role: [Role.learningTrails.course],
        },
        component: UnitComponent,
      },
      {
        path: 'dashboard',
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.dashboard.titulo',
          role: [Role.learningTrails.course],
        },
        component: CourseDeshboardComponent,
      },
      {
        path: 'relatorio/:course_slug',
        data: {
          theme: 'learning-trails',
          breadcrumb: 'breadcrumb.learning-trails.relatorio',
          role: [Role.learningTrails.showcase],
        },
        component: ReportComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LearningTrailsRoutingModule {}
